import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CoinsIcon } from '@infl-ts/ui-advocate-icons';
import { usePreviousProp, useToggle } from '@infl-ts/util-hooks';
import { pluralize } from '@infl-ts/util-string-pluralize';
import { Button, buttonClasses, Fade, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { useHistory } from 'react-router-dom';
import { Link } from '../link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var formatPoints = function formatPoints(points) {
  return points.toLocaleString();
};

var usePointsAnimation = function usePointsAnimation(currentPoints, inRewards) {
  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      awardedPointsShown = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      showAwardedPoints = _useToggle2$.on,
      hideAwardedPoints = _useToggle2$.off;

  var _useToggle3 = useToggle(false),
      _useToggle4 = _slicedToArray(_useToggle3, 2),
      fadeAnimation = _useToggle4[0],
      _useToggle4$ = _useToggle4[1],
      showFadeAnimation = _useToggle4$.on,
      hideFadeAnimation = _useToggle4$.off;

  var _useState = useState(currentPoints),
      startPoints = _useState[0],
      setStartPoints = _useState[1];

  var previousCurrentPoints = usePreviousProp(currentPoints);
  useEffect(function () {
    if (previousCurrentPoints < currentPoints && !inRewards) showAwardedPoints();
    if (previousCurrentPoints !== currentPoints) setStartPoints(previousCurrentPoints);
  }, [currentPoints, setStartPoints, startPoints]);
  useEffect(function () {
    if (startPoints < currentPoints && !inRewards) showFadeAnimation();
  }, [startPoints, awardedPointsShown]);
  return {
    awardedPointsShown: awardedPointsShown,
    startPoints: startPoints,
    fadeProps: {
      "in": fadeAnimation,
      onEntered: hideFadeAnimation,
      onExited: hideAwardedPoints
    }
  };
};

export var PointsButton = function PointsButton(_ref) {
  var currentPoints = _ref.currentPoints;
  var history = useHistory();
  var inRewards = history.location.pathname.startsWith('/rewards');

  var _usePointsAnimation = usePointsAnimation(currentPoints, inRewards),
      fadeProps = _usePointsAnimation.fadeProps,
      awardedPointsShown = _usePointsAnimation.awardedPointsShown,
      startPoints = _usePointsAnimation.startPoints;

  return /*#__PURE__*/_jsx(Button, {
    "aria-label": "".concat(currentPoints, " ").concat(pluralize('point', 'points', currentPoints)),
    sx: _defineProperty({
      mx: 1,
      display: {
        xs: 'none',
        lg: 'inherit'
      }
    }, "&.".concat(buttonClasses.disabled), {
      color: 'inherit'
    }),
    component: Link,
    size: "small",
    variant: inRewards ? 'text' : 'contained',
    color: inRewards ? 'inherit' : 'secondary',
    disabled: inRewards,
    disableElevation: true,
    startIcon: !awardedPointsShown ? /*#__PURE__*/_jsx(CoinsIcon, {}) : null,
    to: "/rewards",
    "data-element": "Button",
    "data-component": "PointsButton",
    "data-source-file": "index.tsx",
    children: awardedPointsShown ? /*#__PURE__*/_jsx(Fade, _objectSpread(_objectSpread({
      timeout: {
        enter: 3000,
        exit: 1000
      }
    }, fadeProps), {}, {
      children: /*#__PURE__*/_jsxs(Typography, {
        variant: "h6",
        sx: {
          color: function color(t) {
            return t.palette.success.main;
          }
        },
        children: ["+ ", (currentPoints - startPoints).toLocaleString()]
      })
    })) : /*#__PURE__*/_jsx(CountUp, {
      start: startPoints,
      end: currentPoints,
      duration: 1.5,
      formattingFn: formatPoints,
      preserveValue: true
    })
  });
};